import React from 'react';
import EducationIcon from '../../onboarding/education/EducationIcon';

function calculateDivWidth(width) {
  width.replace('px', '');

  const widthAsInt = parseInt(width, 10);
  const divWidth = widthAsInt + 20;
  return `${divWidth}px`;
}

export default function EducationIconWithLabel({
  education,
  educationText,
  tenant,
  height = '80px',
  width = '80px',
}) {
  return (
    <div
      className="center-education-icon-with-label"
      style={{ width: calculateDivWidth(width) }}
    >
      <EducationIcon
        education={education}
        educationText={educationText}
        tenant={tenant}
        height={height}
        width={width}
      />
      <div className="center-education-icon-with-label__label">
        {educationText}
      </div>
    </div>
  );
}
